var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59375 10C5.09375 10 1.96875 8.25 0.09375 5.375C-0.03125 5.125 -0.03125 4.875 0.09375 4.75C1.96875 1.75 5.09375 0 8.59375 0C12.0938 0 15.2188 1.75 17.0938 4.625C17.2188 4.875 17.2188 5.125 17.0938 5.25C15.2188 8.25 12.0938 10 8.59375 10ZM1.46875 5C3.09375 7.375 5.71875 8.75 8.59375 8.75C11.4688 8.75 14.0938 7.375 15.7188 5C14.0938 2.625 11.4688 1.25 8.59375 1.25C5.71875 1.25 3.09375 2.625 1.46875 5ZM8.59375 8.125C6.84375 8.125 5.46875 6.75 5.46875 5C5.46875 3.25 6.84375 1.875 8.59375 1.875C10.3438 1.875 11.7188 3.25 11.7188 5C11.7188 6.75 10.3438 8.125 8.59375 8.125ZM8.59375 3.125C7.59375 3.125 6.71875 4 6.71875 5C6.71875 6 7.59375 6.875 8.59375 6.875C9.59375 6.875 10.4688 6 10.4688 5C10.4688 4 9.59375 3.125 8.59375 3.125Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.985e7d33.svg";
export { ForwardRef as ReactComponent };